import React, { useRef, useEffect, useState } from "react";
import JoditEditor from "jodit-react";

const CkEditorBlog = ({
  value = "",
  onChange,
  error,
  placeholder = "Write here...",
}) => {
  const editor = useRef(null);
  const [content, setContent] = useState(value || "");

  // Keep editor content synced with external value
  useEffect(() => {
    setContent(value || "");
  }, [value]);

  // Handle changes inside the editor
  const handleChange = (newContent) => {
    setContent(newContent);
    if (onChange) onChange(newContent);
  };

  // Jodit configuration
  const config = {
    readonly: false,
    height: 400,
    minHeight: 300,
    placeholder: placeholder,
    toolbarAdaptive: false,
    buttons: [
      'source', '|',
      'bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', '|',
      'ul', 'ol', '|',
      'fontsize', 'font', 'paragraph', '|',

      // ADDED COLOR BUTTONS:
      'brush',        // Combined color picker (Text and Background color)
      '|',

      'align', 'undo', 'redo', '|',
      'hr', 'eraser', 'copyformat', '|',
      'link', 'unlink', 'image', 'table', '|',
      'indent', 'outdent', '|',
      'print', 'fullsize',
    ],
  };

  return (
    <div
      style={{
        border: error ? "2px solid red" : "1px solid #ccc",
        borderRadius: "4px",
        overflow: "hidden",
      }}
    >
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        // onBlur={(newContent) => handleChange(newContent)} // fires when focus leaves
        onChange={(newContent) => handleChange(newContent)}
      />
    </div>
  );
};

export default CkEditorBlog;
